<template>
  <div class="create-edit-supply-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateSupply">Nova compra de insumo</h1>
      <h1 class="subtitle is-4" v-else>Editar compra de insumo</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <label class="label">Selecione o Ingrediente</label>
          <b-field>
            <b-autocomplete
              v-model="ingredientSearchText"
              :data="ingredientsList"
              placeholder="Buscar Ingrediente"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getIngredientAsyncData"
              @select="option => (selectedIngredient = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
                <span> ({{ props.option.category.name }})</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>

        <div class="column is-6">
          <label class="label">Selecione o Fornecedor</label>
          <b-field>
            <b-autocomplete
              v-model="supplierSearchText"
              :data="suppliersList"
              placeholder="Buscar Fornecedor"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getSupplierAsyncData"
              @select="option => (selectedSupplier = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
          </b-field>
        </div>

        <div class="column is-6">
          <div class="field">
            <label class="label" for="supplyNfNumber">Nota Fiscal</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="supplyNfNumber"
                name="supplyNfNumber"
                v-model.trim="supply.nfNumber"
              />
            </div>
          </div>
        </div>

        <div class="column is-6">
          <div class="field">
            <label class="label">Preço</label>
            <b-field>
              <currency-input
                v-model="supply.price"
                class="input"
                currency="BRL"
                locale="pt-br"
              />
            </b-field>
          </div>
        </div>

        <div class="column is-6">
          <label class="label">Quantidade</label>
          <b-field>
            <b-input
              type="number"
              placeholder="0,00"
              step="0.01"
              v-model="supply.size"
            ></b-input>
            <p class="control">
              <span class="button is-static">Kg</span>
            </p>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Data de Compra">
            <b-datepicker v-model="supply.purchaseDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Data de Vencimento">
            <b-datepicker v-model="supply.expirationDate" icon="calendar-today">
            </b-datepicker>
          </b-field>
        </div>

        <div class="footer column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium is-primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="
              isPendingAction || !selectedSupplier || !selectedIngredient
            "
          >
            <span v-if="isCreateSupply">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import IngredientService from "../../services/IngredientService";
import QueryBuilder from "../../helpers/QueryBuilder";
import utils from "../../helpers/debounce";
import SupplierService from "../../services/SupplierService";
export default {
  name: "CreateEditSupplyModal",
  data: () => ({
    isCreateSupply: true,
    isPendingAction: false,
    supply: {},
    ingredientsList: [],
    isFetching: false,
    ingredientSearchText: "",
    selectedIngredient: {},
    supplierSearchText: "",
    suppliersList: [],
    selectedSupplier: null
  }),
  computed: {
    ...mapState({})
  },
  methods: {
    ...mapActions({
      createSupply: "supply/createSupply",
      editSupply: "supply/editSupply"
    }),
    getIngredientAsyncData: utils.debounce(function() {
      this.ingredientsList = [];
      let query = {
        name: this.ingredientSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      IngredientService.getIngredients(query)
        .then(({ data }) => {
          this.ingredientsList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),
    getSupplierAsyncData: utils.debounce(function() {
      this.suppliersList = [];
      let query = {
        name: this.supplierSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      SupplierService.getSuppliers(query)
        .then(({ data }) => {
          this.suppliersList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300),

    validateBeforeSubmit() {
      this.$v.supply.$touch();
      if (this.$v.supply.$invalid) {
        return;
      }
      this.supply.ingredient = this.selectedIngredient;
      this.supply.manufacturer = this.selectedSupplier;
      if (this.isCreateSupply) {
        this.createSupply(this.supply)
          .then(() => {
            NotificationsWrapper.success("Insumo cadastrado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o insumo. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editSupply(this.supply)
          .then(() => {
            NotificationsWrapper.success("Insumo atualizado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o insumo. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    }
  },
  validations: {
    supply: {}
  },
  props: {
    supplyParam: {}
  },
  created() {
    if (!this.supplyParam.id) {
      this.isCreateSupply = true;
      this.supply = { price: 0, size: 0 };
    } else {
      this.supply = this.supplyParam;

      this.selectedIngredient = this.supply.ingredient;
      this.selectedSupplier = this.supply.manufacturer;
      this.ingredientSearchText = this.supply.ingredient.name;
      this.supplierSearchText = this.supply.manufacturer.name;
      this.supply.purchaseDate = new Date(this.supplyParam.purchaseDate);
      this.supply.expirationDate = new Date(this.supplyParam.expirationDate);
      this.isCreateSupply = false;
    }
  }
};
</script>

<style scoped></style>
